const TokenKey = 'Admin-Token'
const UserInfoPhoneKey = 'UserInfo-Phone'

export function getToken() {
    return localStorage.getItem(TokenKey);
}

export function setToken(token) {
    return localStorage.setItem(TokenKey,token);
}
export function removeToken() {
    return localStorage.removeItem(TokenKey)
}

export function getUserInfoPhone() {
    return localStorage.getItem(UserInfoPhoneKey)
}
export function setUserInfoPhone(phone) {
    return localStorage.setItem(UserInfoPhoneKey,phone)
}
export function removeUserInfoPhone() {
    return localStorage.removeItem(UserInfoPhoneKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js